// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';

export const AccountOverviewNotificationEditable = dynamic(() =>
  import('./AccountOverviewNotification').then(mod => mod.AccountOverviewNotificationEditable)
);
